export type NavLink = {
  label: string;
  path: string;
};

export const NAV_LINKS: NavLink[] = [
  { label: 'Home', path: '/' },
  { label: 'Our Services', path: '/services' },
  { label: 'How It Works', path: '/how-it-works' },
  { label: 'About Daniella', path: '/about' },
  { label: 'For Suppliers', path: '/for-suppliers' },
  { label: 'Contact', path: '/contact' },
];

export type Service = {
  id: string;
  name: string;
  price: string;
  priceNote: string;
  subheading: string;
  summary: string;
  note: string;
  cta: string;
  path: string;
  icon: string;
};

export const SERVICES: Service[] = [
  {
    id: 'personal-match',
    name: 'Personal Match',
    price: 'Free',
    priceNote: 'No cost',
    subheading: 'Your perfect connection',
    summary:
      'Looking for a photographer, entertainer, stylist or another event specialist? Tell us what you need. If we have a suitable match in our existing network, we\u2019ll personally introduce you.',
    note: 'Existing-network matches only; no extensive new research or guarantee.',
    cta: 'Find My Match',
    path: '/enquire/personal-match',
    icon: 'ri-user-heart-line',
  },
  {
    id: 'event-rescue',
    name: '48-Hour Event Rescue',
    price: '\u00a379',
    priceNote: 'Subject to approval',
    subheading: 'Stuck? Let us help.',
    summary:
      'Need an unusual venue, last-minute replacement or hard-to-find specialist? Daniella will investigate your request and provide suitable options or a meaningful progress update within 48 actual elapsed hours from the agreed start time.',
    note: 'Brief reviewed before acceptance/payment; no guaranteed availability, shortlist or booking.',
    cta: 'Request Event Rescue',
    path: '/enquire/event-rescue',
    icon: 'ri-alarm-warning-line',
  },
  {
    id: 'dream-team',
    name: 'Event Dream Team',
    price: 'From \u00a3199',
    priceNote: 'Subject to a personal quotation',
    subheading: 'Bring your vision together',
    summary:
      'Planning an event that needs several talented suppliers? Share your vision once, and Daniella will source suitable professionals, check their fit where possible and make thoughtful introductions.',
    note: 'Introductions only, not event planning or coordination; scope agreed before acceptance.',
    cta: 'Build My Dream Team',
    path: '/enquire/dream-team',
    icon: 'ri-group-line',
  },
];

export const SUPPLIER_CATEGORIES: string[] = [
  'Venues & Event Spaces',
  'Catering & Drinks',
  'Photography & Videography',
  'Entertainment & Performers',
  'DJs & Music',
  'Flowers & Decorations',
  'Hair, Make-up & Styling',
  'Event Equipment & Furniture',
  'Cakes & Desserts',
  'Transport',
  'Event Staffing',
  'Other \u2013 please specify',
];

/** The 'Other' option value, kept in sync with the last supplier category. */
export const OTHER_CATEGORY_VALUE = 'Other \u2013 please specify';

export const EVENT_TYPES: string[] = [
  'Wedding',
  'Private Celebration or Party',
  'Corporate or Business Event',
  'Charity or Fundraising Event',
  'Other \u2013 please specify',
];

/** The 'Other' option value, kept in sync with the last event type. */
export const OTHER_EVENT_TYPE_VALUE = 'Other \u2013 please specify';

export const CONTACT_METHODS: string[] = ['Phone', 'Email', 'Either'];

export const ENQUIRY_TYPES: string[] = [
  'Finding an event supplier',
  'Existing enquiry',
  'Becoming a supplier',
  'Something else',
];

export const CONTACT = {
  email: 'hello@kor38.com',
  supplierEmail: 'suppliers@kor38.com',
  emailsConfigured: true,
  phone: null as string | null,
  address: null as string | null,
  location: 'London, United Kingdom',
  serviceArea: 'Greater London',
};

export const LEGAL_LINKS: NavLink[] = [
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Customer Terms & Conditions', path: '/customer-terms' },
  { label: 'Website Terms of Use', path: '/website-terms' },
];

export const HOW_IT_WORKS_STEPS = [
  {
    number: '01',
    title: 'Tell us your vision',
    body: 'Share the event, your requirements, budget and location.',
  },
  {
    number: '02',
    title: 'We make the connections',
    body: 'Daniella looks to her network and undertakes agreed research.',
  },
  {
    number: '03',
    title: 'You take it from there',
    body: 'Customers deal and book directly with suppliers.',
  },
];

export const HOW_IT_WORKS_DETAILED = [
  {
    number: '01',
    title: 'Share your requirements',
    body: 'Tell us about your event, date, location, budget and any preferences.',
  },
  {
    number: '02',
    title: 'Daniella reviews your enquiry',
    body: 'She considers whether the request is a good fit for the service and clarifies anything unclear.',
  },
  {
    number: '03',
    title: 'We identify suitable suppliers',
    body: 'Daniella looks to her existing network, or carries out paid research where that has been agreed.',
  },
  {
    number: '04',
    title: 'We make the introduction',
    body: 'Where there is a good fit, a thoughtful introduction is made with the appropriate permission.',
  },
  {
    number: '05',
    title: 'You deal directly with the supplier',
    body: 'You discuss, contract, book and pay the supplier directly. KOR38 is not part of that agreement.',
  },
];